import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  search: null,
  filteredId: [],
};

const filterSlice = createSlice({
  name: "filter",
  initialState,
  reducers: {
    setSearch: (state, action) => {
      if (action.payload.search !== "") {
        state.search = action.payload.search;
      } else state.search = null;
    },
    setFilteredId: (state, action) => {
      state.filteredId = action.payload.filteredId;
    },
  },
});

export const { setFilteredId, setSearch } = filterSlice.actions;
export default filterSlice.reducer;
